<template>
  <div class="views-bulletin">
    <div
      v-if="emergency.isShow"
      class="views-bulletin-alert"
    >
      {{ emergency.title }}
      <br>
      {{ emergency.description }}
    </div>

    <div class="views-bulletin-wrapper">
      <div class="views-bulletin__header-wrapper">
        <div>
          <div class="views-bulletin__header-title">
            電子看板列表
          </div>
          <div class="views-bulletin__header-subtitle">
            可檢視社區所有看板內容及裝置連線狀態
          </div>
        </div>
        <div>
          <el-button
            icon="icon-setting"
            round
            @click="goPageSettings"
          >
            內容管理
          </el-button>
        </div>
      </div>

      <div class="views-bulletin__header-image-wrapper">
        <img
          src="@/assets/img/Bulletin/index-step.png"
          class="views-bulletin__header-image"
          alt="電子看板使用步驟"
        >
      </div>

      <div class="views-bulletin__header-button-wrapper">
        <el-button
          type="danger"
          round
          plain
          @click="goPageEmergency"
        >
          緊急公告
        </el-button>
        <el-button
          icon="icon-plus"
          round
          @click="goPageLayoutNew"
        >
          新增
        </el-button>
      </div>

      <el-table
        class="views-bulletin__table"
        :data="list"
        empty-text="目前無設定任何看板"
      >
        <el-table-column
          label="#"
          type="index"
          :index="filterIndex"
          width="50"
        />
        <el-table-column
          prop="Name"
          label="看板名稱"
          show-overflow-tooltip
        />
        <el-table-column
          prop="ReferenceName"
          label="版型"
          width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span
              class="views-bulletin__table-content__layout-template"
              @click="openDialog('layoutTemplate', scope.row)"
            >{{ scope.row.ReferenceName }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="預覽畫面" width="100">
          <template slot-scope="scope">
            <span
              class="views-bulletin__table-content__page-preview"
              @click="openDialog('pagePreview', scope.row)"
            >預覽畫面</span>
          </template>
        </el-table-column>-->
        <el-table-column
          label="已連線/應連線"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <span class="views-bulletin__table-content__connect-count">{{ scope.row.DisplayDeviceHealth.OnlineCount
            }}/{{ scope.row.DisplayDeviceHealth.OnlineCount + scope.row.DisplayDeviceHealth.OfflineCount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="LastUpdateName"
          label="最後更新者"
          width="150"
          show-overflow-tooltip
        />
        <el-table-column
          prop="LastUpdateAt"
          label="最後更新時間"
          width="150"
          :formatter="dateFormat"
        />
        <el-table-column
          label="操作"
          width="280"
        >
          <template slot-scope="scope">
            <template>
              <el-button
                size="mini"
                plain
                :disabled="scope.row.DisplayDeviceHealth.OnlineCount + scope.row.DisplayDeviceHealth.OfflineCount === 0"
                @click="openDialog('deviceConnectList', scope.row)"
              >
                連線管理
              </el-button>
              <el-button
                size="mini"
                plain
                @click="goPageLayoutEdit(scope.row.Id)"
              >
                編輯
              </el-button>
              <el-button
                type="danger"
                size="mini"
                plain
                :disabled="scope.row.DisplayDeviceHealth.OnlineCount + scope.row.DisplayDeviceHealth.OfflineCount > 0 || isSubmitting || isLoading"
                @click="deleteLayout(scope.row.Id)"
              >
                刪除
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <div
        v-if="isLoading"
        class="views-bulletin__table--loading"
      >
        <div class="spinner">
          <div class="bounce1" />
          <div class="bounce2" />
          <div class="bounce3" />
        </div>
      </div>

      <el-pagination
        v-if="pageParams.total > 0"
        class="views-bulletin__table-pagination"
        background
        layout="total, prev, pager, next, jumper"
        :total="pageParams.total"
        :current-page.sync="pageParams.current"
        @current-change="getLayoutList"
      />

      <ComponentsLayoutTemplate
        :is-visible.sync="layoutTemplateDialog.isShow"
        :title="layoutTemplateDialog.title"
        :content="layoutTemplateDialog.content"
        :image="layoutTemplateDialog.image"
      />
      <ComponentsPagePreview
        :is-visible.sync="pagePreviewDialog.isShow"
        :url="pagePreviewDialog.url"
      />
      <ComponentsDeviceConnectList
        :is-visible.sync="deviceConnectListDialog.isShow"
        :list="deviceConnectListDialog.list"
        :board-id="deviceConnectListDialog.boardId"
        @update="updateLayoutList"
      />
    </div>
  </div>
</template>

<script>
import ComponentsLayoutTemplate from './components/LayoutTemplate'
import ComponentsPagePreview from './components/PagePreview'
import ComponentsDeviceConnectList from './components/DeviceConnectList'

export default {
  components: {
    ComponentsLayoutTemplate,
    ComponentsPagePreview,
    ComponentsDeviceConnectList
  },
  data () {
    return {
      isSubmitting: false,
      isLoading: false,
      emergency: {
        isShow: false,
        title: '',
        description: ''
      },
      layoutTemplateDialog: {
        isShow: false,
        title: '',
        content: [],
        image: ''
      },
      pagePreviewDialog: {
        isShow: false,
        url: ''
      },
      deviceConnectListDialog: {
        isShow: false,
        list: [],
        boardId: ''
      },
      list: [],
      pageParams: {
        maxCount: 10,
        current: 1,
        total: 0
      }
    }
  },
  mounted () {
    this.initPage()
  },
  methods: {
    async initPage () {
      try {
        this.getUrlQuery()
        this.getLayoutList(this.pageParams.current)
        this.getEmergency()
      } catch (error) {
        console.log('initPage error', error)
        this.$message.error('伺服器發生錯誤')
      }
    },
    goPageEmergency () {
      this.$router.push({ path: '/bulletin/emergency' })
    },
    goPageSettings () {
      this.$router.push({ path: '/bulletin/settings' })
    },
    goPageLayoutNew () {
      this.$router.push({ path: '/bulletin/new' })
    },
    getUrlQuery () {
      const query = this.$route.query
      console.log('getUrlQuery query', query)
      if (query.page) this.pageParams.current = +query.page
    },
    async getLayoutList (currentPage = 1) {
      try {
        this.isLoading = true
        if (currentPage !== 1 || this.$route.query.page) this.$router.push({ query: { page: currentPage } })
        const params = {
          Offset: this.pageParams.maxCount * (currentPage - 1),
          MaxCount: this.pageParams.maxCount
        }
        const { data } = await apiBulletin.getLayoutList(params)
        this.pageParams.current = currentPage
        this.pageParams.total = data.Total
        this.list = data.List
      } catch (error) {
        console.log('error', error)
        this.$message.error('伺服器發生錯誤')
      } finally {
        this.isLoading = false
      }
    },
    async getEmergency () {
      try {
        const { data } = await apiBulletin.getEmergencyBeingPublished()
        if (data) {
          this.emergency = {
            isShow: true,
            title: data.Title,
            description: data.Description
          }
        }
      } catch (error) {
        console.log('error', error)
        this.$message.error('伺服器發生錯誤')
      }
    },
    filterIndex (index) {
      return (this.pageParams.current - 1) * 10 + index + 1
    },
    openDialog (name, data) {
      console.log('openDialog data', data)
      this.layoutTemplateDialog.isShow = false
      this.pagePreviewDialog.isShow = false
      this.deviceConnectListDialog.isShow = false

      switch (name) {
        case 'layoutTemplate':
          this.layoutTemplateDialog = {
            isShow: true,
            title: data.ReferenceName,
            content: data.ContentTypes,
            image: data.PreviewImageUrl
          }
          break
        case 'pagePreview':
          this.pagePreviewDialog = {
            isShow: true,
            url: data.PreviewLayoutUrl
          }
          break
        case 'deviceConnectList':
          this.deviceConnectListDialog.boardId = data.Id
          this.getDeviceConnectList(data.Id)
          break
        default:
          break
      }
    },
    async getDeviceConnectList (id) {
      try {
        const boardId = { boardID: id }
        const { data } = await apiBulletin.getDisplayDeviceList(boardId)
        console.log('getDeviceConnectList boardId', boardId)
        console.log('getDeviceConnectList data', data)
        this.deviceConnectListDialog.list = data
        this.deviceConnectListDialog.isShow = true
      } catch (error) {
        console.log('error', error)
        this.$message.error('伺服器發生錯誤')
      }
    },
    dateFormat (data) {
      if (data.LastUpdateAt) return dayjs(data.LastUpdateAt).format('YYYY-MM-DD HH:mm')
    },
    goPageLayoutEdit (id) {
      this.$router.push({ path: `/bulletin/${id}` })
    },
    deleteLayout (id) {
      this.isSubmitting = true
      this.$confirm('看板刪除後將無法復原，確認是否刪除？', '', { confirmButtonText: '確定', cancelButtonText: '取消' })
        .then(async () => {
          try {
            const queryPath = { id }
            await apiBulletin.deleteLayout(queryPath)
            this.$message.success('刪除成功')
            this.getLayoutList(this.pageParams.current)
          } catch (error) {
            console.log('error', error)
            this.$message.error('伺服器發生錯誤')
          } finally {
            this.isSubmitting = false
          }
        })
        .catch(() => { this.isSubmitting = false })
    },
    updateLayoutList () {
      console.log('updateLayoutList')
      this.getLayoutList(this.pageParams.current)
    }
  }
}
</script>

<style lang="sass">

.views-bulletin
  width: 100%
  height: 100%

.views-bulletin-alert
  min-width: 1140px
  box-sizing: border-box
  display: flex
  justify-content: center
  background-color: $warnColor // src/components/HeaderFrame .remindMsg
  color: $white
  font-size: 20px
  line-height: 2
  padding: 8px 16px
  // cursor: pointer

.views-bulletin-wrapper
  min-width: 1140px
  max-width: 90%
  margin: 50px auto 10px auto
  padding: 30px
  color: $mainFontColor
  background-color: $white
  box-sizing: border-box
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
  border-radius: $pageBorderRadius

.views-bulletin__header-wrapper
  display: flex
  justify-content: space-between
  margin-bottom: 20px

.views-bulletin__header-title
  margin-bottom: 10px
  font-size: map-get($fontSize, xx-large)
  font-weight: bold

.views-bulletin__header-subtitle
  font-size: map-get($fontSize,small)
  color: $subFontColor

.views-bulletin__header-image-wrapper
  width: 100%

.views-bulletin__header-image
  width: 100%

.views-bulletin__header-button-wrapper
  display: flex
  justify-content: flex-end
  margin: 20px 0

.views-bulletin__table
  font-size: 15px
  color: $mainFontColor

.views-bulletin__table .el-table
  +basicTable

.views-bulletin__table-content__layout-template,
.views-bulletin__table-content__page-preview
  color: $mainColorDark
  text-decoration: underline
  cursor: pointer

.views-bulletin__table-content__connect-count
  color: $mainColor

.views-bulletin__table--loading
  margin: 25px 0px 0px 0px
  font-size: 20px
  +LoadingEffect

.views-bulletin__table-pagination
  margin-top: 28px
</style>
